
import { Component, Vue, Prop } from "vue-property-decorator";
import NewsItemM from "./components/NewsItemM.vue";
import { getNewsList, getNewsDetail } from "@/apis/about";
import Pagination from "@/components/pagination.vue";
import Breadcrumb from "@/components/Breadcrumb/index.vue";
import { formatUpyunUrl } from "@/utils";
@Component({
  components: {
    NewsItemM,
    Pagination,
    Breadcrumb
  }
})
export default class Case extends Vue {
  formatUpyunUrl = formatUpyunUrl;
  total = 0;
  page = 1 as any;
  per_page = 12;
  list: any = [];
  index: any = 0;
  List = [
    { title: "关于光华", url: "" },
    { title: "光华动态", url: "/news" },
    { title: "内容详情", url: "" }
  ];
  info = {};
  id: any = "";
  loading = false;

  created() {
    if (this.$route.query.id) {
      this.id = this.$route.query.id || "";
    }
    if (this.$route.query.page) {
      this.page = this.$route.query.page;
    }
    this.page = this.page == 0 ? 1 : this.page;
    this.newsList();
    this.getNewsDetail();
  }
  handlePageChange(val: any) {
    this.page = val.page;
    this.newsList();
  }
  async newsList() {
    this.loading = true;
    const { data, total } = await getNewsList({
      page: this.page,
      per_page: this.per_page
    });
    this.total = total;
    if (this.list.length < this.total) {
      this.list.push(...data);
    }

    console.log("🚀 ~ Case ~ newsList ~ data:", data);

    // if (this.index > 0) {
    //   this.$nextTick(() => {
    //     window.location.hash = "#li" + this.index;
    //   });
    // }

    this.loading = false;
  }
  async getNewsDetail() {
    const data = await getNewsDetail({
      id: this.id
    });
    this.info = data;
  }
  clickNews(item: any) {
    this.id = item.id;
    this.getNewsDetail();
  }

  onLazyLoad(event: any) {
    const { scrollTop, scrollHeight, clientHeight } = event.target;
    // 检查是否滚动到底部
    if (scrollTop + clientHeight >= scrollHeight - 10) {
      // 留出10px的缓冲
      if (!this.loading) {
        this.page++;
        this.newsList();
      }
      // console.log(123456);
    }
  }

  mounted() {
    const metaTag1 = document.createElement("meta");
    metaTag1.setAttribute("name", "keywords");
    metaTag1.setAttribute(
      "content",
      "光华介绍，光华师资，光华动态，客户案例，效果看得见，"
    );
    document.head.appendChild(metaTag1);
    const metaTag2 = document.createElement("meta");
    metaTag2.setAttribute("name", "description");
    metaTag2.setAttribute(
      "content",
      "企业培训咨询数字化转型，找光华，企业培训咨询数字化转型 |，找光华，服务一万家企业绩效飞轮*应用实践，帮助一万家企业BLM科学经营T系统落地，到2035年，赋能陪跑企业合计GDP超一万亿规模，用科学经营助推企业高质量发展讲师说明：董权、霍振先、潘亦藩、蔡毅臣、杨波、方永飞 所有老师的名字动态说明：动态标题，客户案例说明：客户案例标题"
    );
    document.head.appendChild(metaTag2);
  }
}
